module.exports = __webpack_public_path__ + "media/images/bi-sort-alpha-down-8ae21fad.svg";